import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  like_activitiesData: any;
  like_activitiesLoading: boolean;
  like_activitiesError: SerializedError | null;
  page: number;
} = {
  like_activitiesData: {},
  like_activitiesLoading: false,
  like_activitiesError: null,
  page: 1,
};

export const like_activitiesFunc = createAsyncThunk(
  'like_activities/like_activitiesFunc',
  async (values: { userId: null | string }) => {
    const data1 = JSON.stringify({
      query: `query Favorites($userId: ID) {
  user(userId: $userId) {
    likedActivities {
      _id
      additionalDetails
      createdAt
      duration
      fee
      hoursBeforeReservationExpires
        externalLink
        externalMail
        externalPhoneNumber
      isReservationRequired
      listing {
        _id
        ageInterval
        category
        companionship
        coverImage
        description
        exteriorOrganizer {
          _id
          name
          imageUrl
          details
          createdAt
          updatedAt
          socialMedia {
            website
            instagram
            twitter
            facebook
            youtube
          }
        }
        format
        images
        subCategory
        title
      }
      location {
        _id
        city
        district
        country
        address {
          description
          title
        }
        lat
        long
        parking
      }
      price
      quota
      schedule {
        _id
        createdAt
        days {
          _id
          activity {
            _id
          }
          date
          day
          startTime
          endTime
          createdAt
          updatedAt
        }
        endDate
        repeatedIntervalType
        startDate
        totalDayCount
        updatedAt
      }
      status
      updatedAt
      updatedBy {
        _id
        displayName
        displayImageUrl
        description
        role 
      }
      title
      createdBy {
        _id
        displayName
        displayImageUrl
        description
      }
    }
  }
    }`,
      variables: {
        userId: values.userId,
      },
    });

    const config = initialConfig(process.env.REACT_APP_BASE_URL_ACTIVITY || '', data1, '');

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const like_activities = createSlice({
  name: 'like_activities',
  initialState,
  reducers: {
    setPaginationAnonymous: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(like_activitiesFunc.pending, (state) => {
      state.like_activitiesLoading = true;
    });
    builder.addCase(like_activitiesFunc.fulfilled, (state, action) => {
      state.like_activitiesLoading = false;
      state.like_activitiesData = action.payload?.data?.user?.likedActivities;
      state.like_activitiesError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(like_activitiesFunc.rejected, (state, action) => {
      state.like_activitiesLoading = false;
      state.like_activitiesError = action.error;
    });
  },
});

export const { setPaginationAnonymous } = like_activities.actions;
export default like_activities.reducer;
